import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { HOME_COURSE_CATEGORY , SEARCH_DOWNLOADAPP , SEARCH_POSTTEACHER,SEARCH_SPECIALITY } from 'src/app/constants';
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { ApiService } from '../api.service';
import { HelperService} from '../helper.service';

@Component({
  selector: 'app-create-post',
  templateUrl: './create-post.component.html',
  styleUrls: ['./create-post.component.scss']
})
export class CreatePostComponent implements OnInit {
  serviceTypeList:[];
  createPost:FormGroup;
  category:string;
  speciallityList:[];
  reqDetails:string;
  mode:string;
  specialityId:string;
  JobId:string;
  isSubmitted:string;

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private formBuilder: FormBuilder,
    private helperService:HelperService) { 

      this.createPost = this.formBuilder.group({
        category: ['',Validators.required],
        specialityId:['',Validators.required],
        mode:['',Validators.required],
        reqDetails:['',Validators.required],
       
      });


    }

  ngOnInit() {

    let vendata = {
      token:this.helperService.studented_atob(this.helperService.getToken()),
      userID:this.helperService.studented_atob(this.helperService.getUserID())
    }

    this.apiService.getVenDetails(vendata).subscribe((res:any)=>{
     
      this.serviceTypeList = res.data.venDetails.data;  

    });

    

  }
  speciallity(){

   
    let specialData = {     
     userID:this.helperService.studented_atob(this.helperService.getUserID()),
     vendorType:this.category
    }
     this.apiService.getspetialityDetails(specialData).subscribe((res:any)=>{       
       this.speciallityList= res.data.venSplDetails.data;                             
       this.speciallityList.forEach(function (value, key) {        
      })
 
     });
 
     
   }

   save(){


    if(this.category == undefined){
      alert("Please Select Category");
      return;
    }
    else if(this.specialityId == undefined){
      alert("Please Select Category");
      return; 
    }

    else if(this.mode == undefined){
      alert("Please Select Instruction Mode");
      return; 
    }
    else if(this.reqDetails == undefined){
      alert("Please Enter requirement");
      return; 
    }

    else {

    let jobData = {
      "postTeacherData":{"vendorTypes":this.category,"speciality":this.specialityId,"deliveryMode":this.mode,
      "requirements":this.reqDetails,"location":""},
      "token":this.helperService.studented_atob(this.helperService.getToken()),
      "userID":this.helperService.studented_atob(this.helperService.getUserID()),
      "hostID":this.helperService.studented_atob(this.helperService.getHostID())
    }
    

    this.apiService.createJob(jobData).subscribe((res:any)=>{
      //res.data.jobDetailsDatadata
      this.JobId = res.data.jobDetailsData.data.id;
     // this.JobId = "SC-JB-" + this.JobId.padStart(8, "0");
      alert( "Post Request Successfully Created ");
      this.router.navigateByUrl(`success-post/`+  this.JobId);
     
   })
  }
}

  getJobNumber() {
    if (!this.JobId) {
      return "";
    }
    return "SC-JB-" + this.JobId.padStart(8, "0");
  }

}
